var React = require('react');

function DarkChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.83672 4.73302L1.29244 0.164167C1.18727 0.0584323 1.04613 0 0.896679 0C0.747233 0 0.606089 0.0584323 0.500923 0.164167L0.168819 0.500848C-0.0498155 0.720665 -0.0498155 1.07682 0.168819 1.29386L3.98247 5.13091L0.163284 8.97353C0.0581181 9.07927 0 9.22117 0 9.37143C0 9.52168 0.0581181 9.66359 0.163284 9.76932L0.498155 10.106C0.603321 10.2117 0.744465 10.2702 0.893912 10.2702C1.04336 10.2702 1.1845 10.2117 1.28967 10.106L5.83672 5.53159C5.94188 5.42586 6 5.28395 6 5.13369C6 4.98066 5.94188 4.83875 5.83672 4.73302Z","fill":"#232323"}));
}

DarkChevronInline.defaultProps = {"width":"6","height":"11","viewBox":"0 0 6 11","fill":"none"};

module.exports = DarkChevronInline;

DarkChevronInline.default = DarkChevronInline;
